<template>
  <v-container fluid>

    <v-list two-line flat >
      <v-subheader><v-icon class="mr-2">mdi-office-building-outline</v-icon> Lista Studi</v-subheader>
      <transition name="fade">
        <v-progress-linear indeterminate rounded height="16" v-if="showLoader"></v-progress-linear>
      </transition>
      <v-alert prominent v-if="error_show" type="warning" class="mt-2 py-2 warning">
        <v-row align="center">
          <v-col class="grow" v-text="error_text"></v-col>
          <v-col class="shrink">
            <v-btn @click="loadItems">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-alert>

      <v-list-item-group v-model="selected_studi" multiple>
        <v-list-item v-if="emptyList">
          <v-list-item-icon>
            <v-icon>mdi-information-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Nessun Dato Disponibile</v-list-item-title>
            <v-list-item-subtitle>Inserisci dati nuovi e ricarica</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider v-if="emptyList"></v-divider>

        <template v-for="(item,i) in items" >
          <v-divider v-if="(i>0)" :key="`divider-${i}`"></v-divider>
          <v-list-item :key="item.id" :value="item.id">
            <template  v-slot:default="{ active, }">
            <v-list-item-action class="ml-2 mr-1">
              <v-checkbox
                  :input-value="active"
                  color="primary"

              ></v-checkbox>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title v-text="item.STUDIO_NAME"></v-list-item-title>
              <v-list-item-subtitle v-text="`https://${item.id}.procedures.cloud`"></v-list-item-subtitle>
            </v-list-item-content>
            </template>

          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
  </v-container>
</template>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<script>
import mj_axios from "@/mj_axios.js";

export default {
  name: "ListaStudiSelectable",
  data: () => ({
    selected_studi: [],
    items: [],
    emptyList: false,
    showLoader: false,
    error_show: false,
    error_text: ""
  }),
  computed: {
    resourceName: function() {
      return this.$route.params == null ? "xx" : this.$route.params.id;
    }
  },
  created: function() {
    this.loadItems();
  },
  methods: {
    loadItems: function() {
      this.error_show = false;
      this.showLoader = true;
      mj_axios
        .get("/api/studi")
        .then(response => {

          if (response.data) {
            this.items = response.data.data;
          }

          this.emptyList = !response.data.data || this.items.length == 0;
          this.showLoader = false;
        })
        .catch(() => {
          
          this.showLoader = false;
          this.error_show = true;
          this.error_text = "Errore nel caricamento dati";
        });
    },

  },
  watch: {
    //se cambia il nome della risorsa ricarica gli items
    selected_studi: function() {
      this.$emit("changeSelected",this.selected_studi);
    }
  }
};
</script>